export default __webpack_public_path__ + "static/media/C_05_06_grafik.dad221f5.png";